<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">{{ $t("minibus.manual.reservation.title") }}</span>
                <h3 class="page-title">{{ $t("minibus.manual.reservation.subtitle") }}</h3>
            </div>
        </div>
        <d-row>
            <d-col lg="10" xl="9" class="mx-auto mt-1">
                <div
                    class="card card-small mb-4 mt-3"
                    v-if="loading"
                    >
                    <div class="card-body">
                        <spinner-dot />
                    </div>
                </div>
                <d-card v-else class="card-small edit-user-details mb-4">
                    <d-card-header class="p-0">
                        <!-- User Details - Background -->
                        <div class="edit-user-details__bg">
                        <img src="@/assets/images/user-profile/up-user-details-background.jpg"
                            alt="User Details Background Image">
                        </div>
                    </d-card-header>
                    <d-card-body class="p-0">
                        <div class="clearfix">
                            <div class="border-0 mt-auto mx-4 pt-2">
                                <d-tabs content-class="mt-3 tab-choice">
                                    <d-tab title="Créer une Réservation Manuelle" active>
                                        <d-form-row class="mx-4">
                                            <d-col lg="8">
                                                <d-form-row>
                                                    <d-col md="12" class="form-group">
                                                        <label for="firstName">{{ $t("minibus.manual.reservation.users") }}</label>
                                                        <select class="form-control" v-model="selectedUser">
                                                            <option v-for="(opt, index) in users" :value="opt">{{ opt.firstName + " " + opt.lastName }}</option>
                                                        </select>
                                                    </d-col>
                                                    <d-col md="6" class="form-group">
                                                        <label for="destination">{{ $t("minibus.request.step.two.destination") }}</label>
                                                        <sup class="text-red">*</sup>
                                                        <d-input
                                                        type="text"
                                                        id="destination"
                                                        v-model="model.destination"
                                                        :state="errors['destination'] === undefined ? null : false"
                                                        />
                                                        <errors :errors="errors" field="destination" />
                                                    </d-col>
                                                    <d-col md="6" class="form-group">
                                                        <label for="title">{{ $t("minibus.request.step.two.reason.title") }}</label>
                                                        <sup class="text-red">*</sup>
                                                        <d-input
                                                        type="text"
                                                        id="title"
                                                        v-model="model.title"
                                                        :state="errors['title'] === undefined ? null : false"
                                                        />
                                                        <errors :errors="errors" field="title" />
                                                    </d-col>
                                                    <d-col md="12" class="form-group">
                                                        <label for="discription">{{ $t("minibus.request.step.two.reason.discription") }}</label>
                                                        <textarea
                                                        id="discription"
                                                        v-model="model.description"
                                                        class="form-control col-md-12 textAreaReservation"
                                                        cols="30"
                                                        rows="7"
                                                        :placeholder="$t('minibus.request.step.two.reason.discription.placeholder')"
                                                        ></textarea>
                                                    </d-col>
                                                    <d-col md="6" class="form-group">
                                                        <label for="datepicker">{{ $t("minibus.manual.reservation.select.starting.date") }}</label>
                                                        <sup class="text-red">*</sup>
                                                        <d-datepicker
                                                        id="datepicker"
                                                        class="pr-1"
                                                        v-model="model.dateRange.from"
                                                        :disabledDates="disabledDatesFrom"
                                                        placeholder="Date de debut"
                                                        @input="checkDates"
                                                        :input-class="['form-control', 'datepicker', 'py-3']"
                                                        :language="fr"
                                                        small
                                                        ></d-datepicker>                                                        
                                                    </d-col>
                                                    <d-col md="6" class="form-group">
                                                        <label>{{ $t("global.select.starting.time") }}</label>
                                                        <sup class="text-red">*</sup>
                                                        <div class="row pl-3 pt-1">
                                                            <div class="d-flex align-items-center justify-content-center">
                                                            <select
                                                                id="hourStart"
                                                                class="form-control mt-0"
                                                                v-model="model.startHour"
                                                                @input="$emit('updateDate', model)"
                                                                @change="checkDates"
                                                            >
                                                                <option v-for="(h, idx) in hours" :key="idx" :value="h">
                                                                {{ h }}
                                                                </option>
                                                            </select>
                                                            <label class="text-label mx-2 mb-0">H:</label>
                                                            </div>

                                                            <div class="d-flex align-items-center justify-content-center">
                                                            <select
                                                                id="minuteStart"
                                                                class="form-control mt-0"
                                                                v-model="model.startMinute"
                                                                @input="$emit('updateDate', model)"
                                                                @change="checkDates"
                                                            >
                                                                <option v-for="(m, idx) in minutes" :key="idx" :value="m">
                                                                {{ m }}
                                                                </option>
                                                            </select>
                                                            <label class="text-label ml-2 mb-0">Min</label>
                                                            </div>
                                                        </div>
                                                    </d-col>
                                                    <d-col md="6" class="form-group">
                                                        <label for="datepicker">{{ $t("minibus.manual.reservation.select.endting.date") }}<sup class="text-red">*</sup></label>
                                                        <d-datepicker
                                                        id="datepicker"
                                                        class="pr-1"
                                                        v-model="model.dateRange.to"
                                                        :disabledDates="disabledDatesTo"
                                                        placeholder="Date de fin"
                                                        @input="checkDates"
                                                        :input-class="['form-control', 'datepicker', 'py-3']"
                                                        :language="fr"
                                                        small
                                                        ></d-datepicker>
                                                    </d-col>
                                                    <d-col md="6" class="form-group">
                                                        <label>{{ $t("global.select.ending.time") }}</label>
                                                        <sup class="text-red">*</sup>
                                                        <div class="row pl-3 pt-1">
                                                            <div class="d-flex align-items-center justify-content-center">
                                                            <select
                                                                id="hourEnd"
                                                                class="form-control mt-0"
                                                                v-model="model.endHour"
                                                                @input="$emit('updateDate', model)"
                                                                @change="checkDates"
                                                            >
                                                                <option v-for="(h, idx) in hours" :key="idx" :value="h">
                                                                {{ h }}
                                                                </option>
                                                            </select>
                                                            <label class="text-label mx-2 mb-0">H:</label>
                                                            </div>

                                                            <div class="d-flex align-items-center justify-content-center">
                                                            <select
                                                                id="minuteEnd"
                                                                class="form-control mt-0"
                                                                v-model="model.endMinute"
                                                                @input="$emit('updateDate', model)"
                                                                @change="checkDates"
                                                            >
                                                                <option v-for="(m, idx) in minutes" :key="idx" :value="m">
                                                                {{ m }}
                                                                </option>
                                                            </select>
                                                            <label class="text-label ml-2 mb-0">Min</label>
                                                            </div>
                                                        </div>
                                                    </d-col>
                                                    <d-col md="12" class="form-group">
                                                        <div>
                                                            <div class="py-2 px-2">
                                                                    <p class="mt-0 d-inline">{{ $t("minibus.managment.demand.decision.minibus.list.title") }}</p>
                                                                    <sup class="text-red">*</sup>
                                                                    <div class="d-flex mt-7 flex-wrap">
                                                                        <div v-for="(bus, idx) in minibusList" :key="idx" class="mb-3 ml-3 d-flex justify-content-center align-items-center">
                                                                            <input
                                                                                type="checkbox"
                                                                                :id=bus.reference
                                                                                :name=bus.reference
                                                                                v-model="bus.checked"
                                                                                @click="checkboxClicked(bus)"
                                                                                class="custom-checkbox-input"
                                                                            />
                                                                            <label class="ml-2 m-0 custom-checkbox-label" :for=bus.reference>{{
                                                                                bus.name
                                                                            }}</label>
                                                                            <span v-if="bus.available" class="available ml-2">{{ $t("minibus.manual.reservation.Disponible") }}</span>
                                                                            <span v-else class="notAvailable ml-2">{{ $t("minibus.manual.reservation.Indisponible") }}</span>
                                                                        </div>
                                                                    </div>
                                                            </div>
                                                        </div>                                                       
                                                    </d-col>
                                                </d-form-row>
                                            </d-col>
                                        </d-form-row>
                                    </d-tab>
                                </d-tabs>
                            </div>
                        </div>
                    </d-card-body>
                    <d-card-footer class="border-top">
                        <d-div class="d-flex justify-content-around">
                            <div class="col">
                                <d-button size="sm" class="btn-accent float-right  d-table" @click="saveReservation">
                                    {{ $t('global.save') }}
                                </d-button>
                            </div>
                        </d-div>
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import Errors from '../../components/error/errors.vue';
import ErrorsHelper from '../../helper/ErrorsHelper';
import SortedSelect from '../../components/form/SortedSelect.vue';
import { fr } from 'vuejs-datepicker/dist/locale';
import { min } from "moment";


export default {
    name: "minibus-manuel-reservation",
    components: {
        SpinnerDot,
        SortedSelect,
        Errors
    },
    data() {
        return {
            disabledDatesFrom: {
                to: new Date(),
            },
            loading: true,
            selectedUser: null,
            minibusList: [],
            requiredFields: ['title', 'destination'],
            minibusChecked: null,
            edit: false,
            users: null,
            model: {
                firstName: '',
                lastName: '',
                email: '',
                title: '',
                description: '',
                destination: '',
                startHour: '08',
                startMinute: '00',
                endHour: '17',
                endMinute: '00',
                dateRange: {
                    from: new Date(),
                    to: new Date(),
                },
            },
            fr,
            adminRef: [],
            recepRef: [],
            hours: [
            '00',
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20',
            '21',
            '22',
            '23',
        ],
        minutes: ['00', '10', '20', '30', '40', '50'],
        errors: {}
        };
    },
    mounted() {
        this.$services.minibusManagement.findAll().then(({data}) => {
            this.minibusList = data.data.filter(minibus => minibus.available == true);
                for (let bus in this.minibusList) {
                    this.minibusList[bus].checked = false;
                }
            this.checkDates();
            this.loading = false;
            })
        this.$services.user.getUsers().then(({data}) => {
            this.users = data;
        });
        this.$services.user.getUsers()
            .then((data) => {
                data.data.forEach((user) => {
                if(user.permissions[0] && user.permissions[0].groupReference == '_super_admin'){
                    this.adminRef.push(user.reference);
                }
                if(user.permissions[0] && user.permissions[0].groupReference == '_receptionist'){
                    this.recepRef.push(user.reference);
                }
                })
            }
            ).catch ((e) => console.log("error: ", e))
    },
    computed: {
        user() {
            return this.$store.state.user.informations;
        },
        disabledDatesTo() {
            return {
                to: this.model.dateRange.from || new Date(),
            };
        },  
    },
    methods: {
        getFullDate(date, Hour, Minute) {
            let hours = parseInt(Hour) * 60 *60 * 1000 ;
            let min = parseInt(Minute) * 60 * 1000 ;
            let calculatedDate = new Date(date.toISOString().split('T')[0]).subtractHours(1).getTime() + hours + min ;
            return new Date(calculatedDate) ;
        },
        saveReservation() {
            let cleanedMinibusList = [];
            this.minibusList.forEach((minibus, index) => {
                if (minibus.checked == true) {
                    cleanedMinibusList.push({
                        reference : minibus.reference
                    });
                }
            })
            if (this.model.destination != "" && this.model.title != "" && cleanedMinibusList.length != 0 && this.selectedUser != null){
            this.loading = true;
            this.minibusChecked = this.minibusList.filter(minibus => minibus.checked == true);
            let requestSent = {
                    status: "ACCEPTED",
                    answers: [
                        {
                        groupReference: "_super_admin",
                        position: null,
                        userReference: this.user.reference,
                        status: "ACCEPTED"
                        },
                        {
                        groupReference: "_receptionist",
                        position: null,
                        userReference: this.user.reference,
                        status: "ACCEPTED"
                        }
                    ],
                    minibusList: cleanedMinibusList,
                    title: this.model.title,
                    firstName: this.selectedUser.firstName,
                    lastName: this.selectedUser.lastName,
                    email: this.selectedUser.email,
                    userReference: this.selectedUser.reference,
                    authorized: [this.selectedUser.reference],
                    description: this.model.description,
                    destination: this.model.destination,
                    userFirstName: this.user.firstName ,
                    userLastName: this.user.lastName ,
                    manuelReservation: true,
                    fromDate: this.getFullDate(this.model.dateRange.from, this.model.startHour, this.model.startMinute),
                    toDate: this.getFullDate(this.model.dateRange.to, this.model.endHour, this.model.endMinute),
                }
            if (ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)) {
                this.loading = true;
                this.$services.minibusRequest.createRequest(requestSent).then((res) => {
                    this.minibusChecked.forEach((minbus) => {
                        let model = {
                            fromDate: this.getFullDate(this.model.dateRange.from, this.model.startHour, this.model.startMinute),
                            toDate: this.getFullDate(this.model.dateRange.to, this.model.endHour, this.model.endMinute),
                            requestReference: res.data.reference,
                            minibusReference: minbus.reference
                        }
                        this.$services.minibusManagement.createReservation(model).then((resp) => {
                            this.loading = false;
                            this.$miniToastr.success(this.$t("minibus.request.success"));
                            this.$router.push("/demandes/minibus/management");  
                        })
                        .catch(error => {
                            this.$miniToastr.error("Une erreur s'est produite."); 
                            });
                    })
                }
                )
                .catch(error => {
                this.$miniToastr.error("Une erreur s'est produite."); 
                });
            }

        } else {
            this.$miniToastr.error("Veuillez remplir tous les champs obligatoires."); 
        }
        },
        checkDates() {
            if (this.model.dateRange.to < this.model.dateRange.from) {
                this.model.dateRange.to = this.model.dateRange.from ;
            }
            this.$services.minibusManagement.reservationsCheckConflict({fromDate: this.getFullDate(this.model.dateRange.from, this.model.startHour, this.model.startMinute), toDate: this.getFullDate(this.model.dateRange.to, this.model.endHour, this.model.endMinute)})
                .then((res) => {
                    for (let minibus in this.minibusList) {
                        this.minibusList[minibus].available = true;
                        for (let bus in res.data) {
                            if(this.minibusList[minibus].checked == false && this.minibusList[minibus].reference == res.data[bus].minibusReference) {
                                this.minibusList[minibus].available = false;
                            }
                        }
                    }
                    })

        }
    }
}
</script>

<style scoped>
td {
    text-align: start !important;
}

.col-md-12 {
    padding: 12px auto;
}

.available {
    display: block;
    border: 1px solid #17c671;
    width: 120px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(23, 198, 113, 0.24);
    color: #17c671;
    margin: auto 0;
    text-align: center;
}

.notAvailable {
    display: block;
    border: 1px solid #c4183c;
    width: 120px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(196, 24, 60, 0.24);
    color: #c4183c;
    margin: auto 0;
    text-align: center;
}

.textAreaReservation {
    height: auto;
    padding: 0.4375rem 0.75rem;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #e1e5eb;
    font-weight: 300;
    will-change: border-color, box-shadow;
    border-radius: 0.25rem;
    box-shadow: none;
    width: 100%;
}

.text-red {
  color: red;
  font-size: 16px;
  font-weight: 900;
}
</style>